angular.module('picmonicng').directive('faqTitle', [
  function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.on('click', function () {
          element.parent().find('.faq-answer').toggleClass('faq-answer--open');
        });
      },
    };
  },
]);
